import DataTable from '@/containers/data_table_ml/DataTable';
import './TablePage.less';
import React from 'react';

const TestPage = (props) => {
  const { outList = [] } = props || {};
  const columns = [
    {
      title: '输出字段',
      dataIndex: 'id',
      key: 'id',
      width: 200,
    },
    {
      title: '输出项',
      dataIndex: 'value',
      key: 'value',
      width: 200,
    },
  ];

  return (
    <DataTable
      border={true}
      className="demo-test"
      style={{ border: '1px solid #edf0f0' }}
      columns={columns}
      rowSelection={false}
      scroll={{ y: 'calc(50vh - 140px - 2rem)' }}
      dataSource={outList}
      // loading={loading}
    />
  );
};
export default TestPage;
